import Next from "@assets/restaurant/slider-next.svg";
import Prev from "@assets/restaurant/slider-prev.svg";
import KakiMakanDesktopVideo from "@components/Layouts/KakiMakanVideo/KakiMakanDesktopVideo";
import KakiMakanMobileVideo from "@components/Layouts/KakiMakanVideo/KakiMakanMobileVideo";
import useKakiMakanVideo from "@hooks/useBrightcoveVideo/useKakiMakanVideo";
import { useRef, useState } from "react";

export default function KakiMakanVideoSection() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { playing, videos, handleOnClickThumbnail, handleOnEndedVideo } =
    useKakiMakanVideo({ containerRef });

  const [page, setPage] = useState(0);

  const ITEMS_PER_PAGE = 8;
  const start = page * ITEMS_PER_PAGE;
  const paginated = videos.slice(start, start + ITEMS_PER_PAGE);

  const sliderButtonStyle =
    "flex justify-center w-[36px] h-[36px] p-1.5 bg-brand-primary rounded-full disabled:opacity-30";
  const sliderImageStyle = "w-6 h-6";

  return (
    <div className="flex flex-col lg:-mx-[5px]">
      <div className="flex flex-col w-full gap-5">
        <div className="flex justify-center relative">
          <span className="text-center font-secondary text-blue-300 text-[38px] font-semibold leading-[120%]">
            Video Kaki Makan
          </span>
          <div className="hidden lg:flex gap-4 absolute top-[5px] -right-[0.5px]">
            <button
              disabled={page === 0}
              onClick={() => {
                setPage((p) => p - 1);
              }}
              className={sliderButtonStyle}
            >
              <img
                src={Prev}
                alt="prev"
                width={24}
                className={sliderImageStyle}
              />
            </button>
            <button
              disabled={start + ITEMS_PER_PAGE >= videos.length}
              onClick={() => {
                setPage((p) => p + 1);
              }}
              className={sliderButtonStyle}
            >
              <img
                src={Next}
                alt="next"
                width={24}
                className={sliderImageStyle}
              />
            </button>
          </div>
        </div>
        <div className="hidden lg:block">
          <KakiMakanDesktopVideo
            containerRef={containerRef}
            paginated={paginated}
            handleOnEndedVideo={handleOnEndedVideo}
            handleOnClickThumbnail={handleOnClickThumbnail}
            playing={playing}
          />
        </div>
        <div className="lg:hidden">
          <KakiMakanMobileVideo
            videos={videos}
            containerRef={containerRef}
            handleOnEndedVideo={handleOnEndedVideo}
            handleOnClickThumbnail={handleOnClickThumbnail}
            playing={playing}
          />
        </div>
      </div>
    </div>
  );
}
